module.exports = __webpack_public_path__ + "img/Wide-Belt.adacce79.jpg";